module.exports = __webpack_public_path__ + "static/media/trigger_soundi 9-2-Audio 1.d0b22066.mp3";